import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class TrainingStaffDate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.training_certification_staff_id,
      date_start: this.props.date_start,
      date_finish: this.props.date_finish,
      status: this.props.status,
      updated: this.props.updated,
    };

    this.locale = getLocale();

    //bind específico
    this.edit = this.edit.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_certification_staff_id !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)){
      this.setState({
        id: newProps.training_certification_staff_id,
        date_start: newProps.date_start,
        date_finish: newProps.date_finish,
        status: newProps.status,
        loaded: 1,
      });
    } else {
      this.setState({
        id: newProps.training_certification_staff_id,
        date_start: newProps.date_start,
        date_finish: newProps.date_finish,
        status: newProps.status,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado/tripulante/data', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({date_start: responseJson.data.date_start_str, date_finish: responseJson.data.date_finish_str});
        
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        {(this.props.status === 1 || this.props.status === 3) ? 
          <form onSubmit={this.edit} className="row"> 
            <RequestApi ref={'request_api'} />
            <div className="col-md-4 col-md-offset-1">
              <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabAulas.tabInstrutores.formularioDatas.placeholder.DataDeInicio} />
            </div>
            <div className="col-md-1"> {this.locale.Treinamentos.EditarTreinamento.tabAulas.tabInstrutores.formularioDatas.a} </div>
            <div className="col-md-4">
              <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabAulas.tabInstrutores.formularioDatas.placeholder.DataDeTermino} />
            </div>
            <div className="col-md-2 text-left"><button className="btn btn-primary"><i className="fa fa-fw fa-save"></i></button></div>
          </form>
        : 
          ''
        }        
      </div>
    );
  }
}

export default TrainingStaffDate;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingStaffDate.js